var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSolutions(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 183,
    height: 172,
    viewBox: "0 0 183 172",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M171.406 168H5.59366C4.71328 168 4 167.118 4 166.03C4 164.942 4.71365 164.06 5.59366 164.06H173V166.03C173 167.118 172.286 168 171.406 168Z",
    fill: "#7846D1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M65.1807 168H5.59366C4.71328 168 4 167.118 4 166.03V164.06H66.7748V166.03C66.7748 167.118 66.0611 168 65.1807 168Z",
    fill: "#6020BD"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M89.9492 88.9641C82.8486 105.829 74.8702 112.7 74.8702 112.7L81.7603 126.297L93.7922 110.843L89.9492 88.9641Z",
    fill: "#6020BD"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M107.557 84.939L89.951 88.9644C88.8359 130.135 88.4179 164.055 88.4179 164.055H120.02C120.02 164.055 120.937 101.01 115.853 87.2548L107.557 84.939Z",
    fill: "#6020BD"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M105.512 105.92L114.089 105.023",
    stroke: "#7846D1",
    strokeWidth: 4.58196,
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M101.574 97.0712C101.574 97.0712 107.018 142.989 102.281 161.569",
    stroke: "#7846D1",
    strokeWidth: 1.14549,
    strokeMiterlimit: 10
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M95.8742 120.072C95.8742 120.072 101.133 122.688 107.95 122.965C114.767 123.242 110.526 127.725 100.419 126.875",
    stroke: "#7846D1",
    strokeWidth: 1.14549,
    strokeMiterlimit: 10
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M97.2297 83.2646L101.575 97.533L107.556 84.9386L103.614 76.9759L97.2297 83.2646Z",
    fill: "#E9A394"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M101.574 97.5334L109.685 94.7656L107.555 84.939L101.574 97.5334Z",
    fill: "#9C78ED"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M98.1947 86.4352L93.7928 92.5122L101.574 97.533L98.1947 86.4352Z",
    fill: "#9C78ED"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M81.7624 126.297C81.7624 126.297 84.3333 119.671 78.8132 111.136C75.7523 106.403 74.3418 98.2361 74.3418 98.2361L69.7429 99.1006L73.9541 126.298H81.7624V126.297Z",
    fill: "#E9A394"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M68.8023 89.7083L66.9193 91.8237L69.4367 94.5702L61.5541 94.4043L61.3851 97.7473L69.7422 99.1002L74.3415 98.2357L68.8023 89.7083Z",
    fill: "#E9A394"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M70.1799 94.9152L62.6168 91.0593L62.1286 92.7199L68.4412 95.9987L70.1799 94.9152Z",
    fill: "#E9A394"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M115.853 87.2548C115.853 87.2548 126.012 94.4048 129.221 121.187L117.434 124.702L115.853 87.2548Z",
    fill: "#6020BD"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M93.7851 65.828L89.9481 77.9635L92.8823 79.0794L93.7851 85.9147L103.153 83.2643L104.507 64.7121L93.7851 65.828Z",
    fill: "#E9A394"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M100.038 68.7118H92.8747L93.656 66.0956L100.038 65.6076V68.7118Z",
    fill: "#E37A82"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M103.779 74.2484C103.779 74.2484 99.2086 73.0799 99.2086 67.2362C99.2086 67.2362 92.4276 68.377 90.0867 63.8276C87.3139 58.4386 91.5513 52.2456 95.0508 53.5037C95.0508 53.5037 92.8456 56.2054 96.1947 56.5228C98.5832 56.7493 102.948 52.8217 104.506 56.6203C104.506 56.6203 116.528 60.0142 107.553 73.8589L103.779 74.2484Z",
    fill: "#16005C"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M99.2101 66.7741C99.2101 66.7741 90.1457 68.9388 88.25 60.9045C87.1416 56.2077 90.9506 53.5328 90.9506 53.5328",
    stroke: "#16005C",
    strokeWidth: 2.29098,
    strokeMiterlimit: 10
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M95.3745 77.5768C97.2643 77.5768 98.7962 75.6833 98.7962 73.3475C98.7962 71.0118 97.2643 69.1183 95.3745 69.1183C93.4848 69.1183 91.9528 71.0118 91.9528 73.3475C91.9528 75.6833 93.4848 77.5768 95.3745 77.5768Z",
    stroke: "#16005C",
    strokeWidth: 0.572745,
    strokeMiterlimit: 10
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M98.6132 71.9786L103.487 72.3085",
    stroke: "#16005C",
    strokeWidth: 0.572745,
    strokeMiterlimit: 10
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M109.686 75.3135C109.686 77.9329 106.846 80.0561 104.727 80.0561C102.608 80.0561 102.011 77.9325 102.011 75.3135C102.011 72.6946 103.73 70.5709 105.849 70.5709C107.967 70.5709 109.686 72.6946 109.686 75.3135Z",
    fill: "#E9A394"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M127.815 121.606V143.476H118.992L118.257 124.456L127.815 121.606Z",
    fill: "#E9A394"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M89.2634 116.661L89.6339 101.422L83.9187 123.527L89.2634 116.661Z",
    fill: "#E0D5F8"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M97.6835 84.7157L103.155 83.2644L98.6693 87.9926L97.6835 84.7157Z",
    fill: "#E37A82"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M94.4477 75.3135C94.8094 75.3135 95.1027 74.5576 95.1027 73.6251C95.1027 72.6926 94.8094 71.9367 94.4477 71.9367C94.086 71.9367 93.7928 72.6926 93.7928 73.6251C93.7928 74.5576 94.086 75.3135 94.4477 75.3135Z",
    fill: "#16005C"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M96.2285 69.5186C96.2285 67.2563 94.7712 68.7793 94.7712 68.7793L96.2285 69.5186Z",
    fill: "#16005C"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M94.7712 79.5342L96.8554 78.8485C96.8554 78.8485 97.7485 88.403 94.7712 79.5342Z",
    fill: "white"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M49.8609 122.36C49.8609 122.36 63.9219 119.67 64.1982 149.977C64.243 154.895 66.7765 164.06 66.7765 164.06H54.0336L49.8609 122.36Z",
    fill: "#9C78ED"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M35.1583 119.671L26.6599 122.15L29.2528 164.06H62.3193C62.3193 164.06 61.2101 130.901 48.7405 120.953L35.1583 119.671Z",
    fill: "#9C78ED"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M26.6614 122.15C17.9021 124.619 19.9526 132.929 21.6438 149.993C17.2718 154.382 21.4662 156.357 21.4662 156.357C16.6647 162.648 22.6547 164.06 22.6547 164.06H38.6451C38.6451 164.06 35.4267 119.679 26.6614 122.15Z",
    fill: "#9C78ED"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M37.6963 154.38L33.8589 132.608",
    stroke: "#7846D1",
    strokeWidth: 1.14549,
    strokeMiterlimit: 10
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M22.6532 164.06C22.6532 164.06 25.353 156.399 33.8858 152.547C40.9606 149.353 51.3095 157.643 57.9342 149.766L59.1612 158.635L38.6436 164.06H22.6532Z",
    fill: "#E9A394"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M50.7841 98.0861L57.1102 109.988L53.0507 111.779L52.349 121.451L40.1493 116.212L41.2988 96.5382L50.7841 98.0861Z",
    fill: "#E9A394"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M41.3993 110.588L35.1633 119.671L43.1604 131.784L46.7672 117.636L41.3993 110.588Z",
    fill: "#E37A82"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M43.4848 104.964L52.4082 101.138L50.7861 98.0859L41.9711 99.2198L43.4848 104.964Z",
    fill: "#E37A82"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M42.7132 109.133C42.7132 109.133 45.4149 115.819 43.5352 102.932C43.5352 102.932 46.099 103.287 48.1069 99.1053C48.1069 99.1053 47.4829 105.92 53.3727 99.1053C59.2625 92.2899 51.7749 86.9577 42.6257 88.964C34.6955 90.7032 26.7598 96.241 38.3584 115.016L42.7132 109.133Z",
    fill: "#16005C"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M41.27 111.792C40.6614 112.8 39.6158 113.716 38.5287 113.911C36.3545 114.303 34.2311 112.181 33.9145 109.494C33.5978 106.807 34.6961 105.411 36.87 105.02C38.0921 104.8 39.507 105.248 40.5683 106.159C40.8891 106.653 41.27 111.792 41.27 111.792Z",
    fill: "#E9A394"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M49.8746 108.077C50.2002 107.967 50.3007 107.134 50.099 106.216C49.8974 105.298 49.47 104.642 49.1444 104.751C48.8188 104.86 48.7183 105.693 48.92 106.612C49.1216 107.53 49.549 108.186 49.8746 108.077Z",
    fill: "#16005C"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M47.4019 104.077C47.4019 104.077 47.0849 101.867 48.7447 102.931L47.4019 104.077Z",
    fill: "#16005C"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M34.162 120.042L35.6098 117.987L35.0786 116.463L38.356 115.016L47.7583 120.86L48.1045 125.323L46.5135 124.701L43.9161 136.668L34.162 120.042Z",
    fill: "#9C78ED"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M42.6521 122.964L48.1044 125.322L47.7583 120.86",
    stroke: "#7846D1",
    strokeWidth: 1.14549,
    strokeMiterlimit: 10
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M43.535 102.932C43.535 102.932 44.6318 110.822 46.2359 112.444C46.7627 112.977 47.7597 111.622 52.3496 111.508C55.156 111.439 55.1538 123.547 51.4296 123.2C47.7055 122.853 42.046 119.983 41.1978 111.157C40.4542 103.415 43.535 102.932 43.535 102.932Z",
    fill: "#16005C"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M48.1043 113.911C48.1043 113.911 49.0509 116.09 50.9163 114.614",
    stroke: "#C4C6C5",
    strokeWidth: 1.14549,
    strokeMiterlimit: 10
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M69.3864 159.077H37.9962V161.951C37.9962 163.116 38.7599 164.059 39.7016 164.059H69.3864C70.3284 164.059 71.0918 163.115 71.0918 161.951V161.185C71.0922 160.021 70.3284 159.077 69.3864 159.077Z",
    fill: "#1A0B42"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M94.8806 130.261H58.3659C57.2807 130.261 56.3644 131.258 56.2268 132.588L53.2851 161.057C53.1206 162.65 54.1248 164.06 55.4242 164.06H91.9389C93.0242 164.06 93.9404 163.063 94.078 161.733L97.0197 133.264C97.1842 131.67 96.1801 130.261 94.8806 130.261Z",
    fill: "#1A0B42"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M96.6469 130.261H60.1322C59.047 130.261 58.1307 131.258 57.9931 132.588L55.0514 161.057C54.8869 162.65 55.8911 164.06 57.1905 164.06H93.7052C94.7905 164.06 95.7067 163.063 95.8443 161.733L98.786 133.264C98.9505 131.67 97.9464 130.261 96.6469 130.261Z",
    fill: "#403657"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M79.2689 150.219C80.7895 148.436 80.9692 145.618 79.6704 143.926C78.3715 142.234 76.0859 142.309 74.5653 144.092C73.0447 145.875 72.8649 148.692 74.1638 150.384C75.4627 152.076 77.7483 152.002 79.2689 150.219Z",
    fill: "white"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M95.8499 163.819H50.3987",
    stroke: "#6020BD",
    strokeWidth: 1.14549,
    strokeMiterlimit: 10
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M115.936 125.72L131.025 126.074L127.604 103.26L119.581 104.383C119.581 104.383 115.968 110.976 118.821 116.102C122.041 121.886 115.605 122.101 115.936 125.72Z",
    fill: "#16005C"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M119.581 104.383C119.581 104.383 115.967 110.976 118.821 116.102C122.041 121.886 115.605 122.101 115.936 125.72",
    stroke: "#16005C",
    strokeWidth: 2.29098,
    strokeMiterlimit: 10
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M122.59 122.964C122.59 122.964 115.725 131.291 112.105 162.669H119.747L122.59 122.964Z",
    fill: "#16005C"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M140.736 120.645L137.748 162.669H115.553L118.316 146.619C118.316 146.619 109.866 141.17 122.592 122.964L125.755 120.953L139.497 119.671L140.736 120.645Z",
    fill: "#C3C8FF"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M122.589 141.772C122.589 141.772 121.259 144.589 122.538 146.85L120.654 162.669",
    stroke: "#16005C",
    strokeWidth: 1.14549,
    strokeMiterlimit: 10
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M119.488 146.691L132.344 147.16",
    stroke: "#16005C",
    strokeWidth: 1.14549,
    strokeMiterlimit: 10
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M134.877 154.602L133.518 134.389",
    stroke: "#16005C",
    strokeWidth: 1.14549,
    strokeMiterlimit: 10
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M140.733 120.645C140.733 120.645 141.959 122.551 143.378 126.97C145.39 133.237 147.79 144.559 147.632 162.668H137.745L140.733 120.645Z",
    fill: "#C3C8FF"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M147.632 164.055C147.632 164.055 142.692 150.091 130.267 154.087C116.7 158.45 111.662 157.635 111.662 157.635L110.634 164.055H147.632Z",
    fill: "#E9A394"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M134.701 151.153L130.293 152.371L140.306 164.055H149.745C149.745 164.055 145.677 151.863 134.701 151.153Z",
    fill: "#16005C"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M134.974 154.777L137.074 153.984",
    stroke: "#C3C8FF",
    strokeWidth: 1.14549,
    strokeMiterlimit: 10
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M111.663 157.635L105.216 155.987L100.595 164.055H110.634L111.663 157.635Z",
    fill: "#E9A394"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M122.59 141.772L134.569 126.966L132.344 125.667L140.734 120.645L136.881 117.615H127.914L122.59 125.84L124.061 126.297L122.59 127.572V141.772Z",
    fill: "#16005C"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M130.961 122.647L134.874 119.305L130.65 107.63L124.102 112.713L125.947 122.397L122.586 141.772L130.961 122.647Z",
    fill: "#E9A394"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M124.63 115.479L129.225 112.517L125.123 118.065L124.63 115.479Z",
    fill: "#E37A82"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M116.235 98.5769L114.229 112.321H117.239L120.618 118.065L129.225 112.517L123.205 95.9399L116.235 98.5769Z",
    fill: "#E9A394"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M115.747 101.91L115.546 103.42L123.483 102.082L123.362 100.201L115.747 101.91Z",
    fill: "#E37A82"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M138.174 97.5328C136.187 90.8754 133.758 88.3086 133.758 88.3086C128.888 82.3282 120.565 88.9643 120.565 88.9643C109.899 85.7733 114.228 102.141 114.228 102.141L122.915 100.824C124.129 109.831 128.473 105.27 128.473 105.27L130.499 109.786C130.499 109.786 128.455 112.019 130.586 115.847C132.34 118.998 128.139 120.072 129.225 123.427L146.015 119.126C146.015 105.471 141.765 109.565 138.174 97.5328Z",
    fill: "#16005C"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M113.548 102.247C113.548 102.247 112.012 92.9015 114.833 89.8606C116.305 88.2749 120.938 88.9642 120.938 88.9642",
    stroke: "#16005C",
    strokeWidth: 2.29098,
    strokeMiterlimit: 10
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M147.115 118.732C147.115 118.732 148.456 112.517 141.15 105.47",
    stroke: "#16005C",
    strokeWidth: 2.29098,
    strokeMiterlimit: 10
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M128.723 110.364C130.721 110.364 132.34 108.362 132.34 105.893C132.34 103.424 130.721 101.423 128.723 101.423C126.726 101.423 125.106 103.424 125.106 105.893C125.106 108.362 126.726 110.364 128.723 110.364Z",
    fill: "#E9A394"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M119.489 111.816L121.731 111.135C121.731 111.135 122.518 119.04 119.489 111.816Z",
    fill: "white"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M117.623 107.145C117.623 107.145 118.336 101.769 119.898 107.145",
    stroke: "#6020BD",
    strokeWidth: 0.572745,
    strokeMiterlimit: 10
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M118.172 103.056C118.172 103.056 119.041 101.236 120.071 103.056H118.172Z",
    fill: "#16005C"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M84.4283 54.6217C83.1273 50.1499 79.0372 47.9107 75.4521 49.8214C72.3669 51.4658 70.7313 55.7921 71.6884 59.7732C72.2233 61.999 73.4315 63.7206 74.9445 64.7251C76.3411 65.652 77.5396 66.9749 78.4181 68.6055L78.6716 69.0759L83.6948 66.8437L83.6481 66.2841C83.4825 64.3028 83.7629 62.3206 84.3554 60.4682C84.9333 58.6601 85.0021 56.5947 84.4283 54.6217Z",
    fill: "#C3C8FF"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M84.4283 54.6217C83.1273 50.1499 79.0372 47.9107 75.4521 49.8214C72.3669 51.4658 70.7313 55.7921 71.6884 59.7732C72.2233 61.999 73.4315 63.7206 74.9445 64.7251C76.3411 65.652 77.5396 66.9749 78.4181 68.6055L78.6716 69.0759L83.6948 66.8437L83.6481 66.2841C83.4825 64.3028 83.7629 62.3206 84.3554 60.4682C84.9333 58.6601 85.0021 56.5947 84.4283 54.6217Z",
    fill: "#C3C8FF"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M79.8198 67.2448L75.8157 60.2649C75.8157 60.2649 75.8885 58.8515 77.1454 59.0756C78.4022 59.2997 79.1525 61.7514 78.2557 61.3558C77.3588 60.9603 77.0415 58.0784 78.7387 57.639C80.4355 57.1996 81.0026 61.9648 80.065 61.0467C79.1275 60.1286 79.3252 57.0947 81.1424 57.0698L82.2086 67.1367",
    stroke: "white",
    strokeWidth: 1.14549,
    strokeMiterlimit: 10
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M83.5788 71.6147L81.2199 72.6631C80.3231 73.0619 79.3343 72.4862 79.012 71.3777L78.5133 69.6634C78.1907 68.555 78.6565 67.3328 79.5533 66.9345L81.9122 65.8861C82.8091 65.4873 83.7975 66.0631 84.1201 67.1715L84.6188 68.8858C84.941 69.9943 84.4756 71.216 83.5788 71.6147Z",
    fill: "#16005C"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M84.1336 64.3338L77.0298 67.4904L78.2765 71.7767L85.3804 68.62L84.1336 64.3338Z",
    fill: "#7846D1"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M77.9493 47.0221L77.2406 42",
    stroke: "#C3C8FF",
    strokeWidth: 1.14549,
    strokeMiterlimit: 10
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M72.8285 50.0134L69.4349 45.9163",
    stroke: "#C3C8FF",
    strokeWidth: 1.14549,
    strokeMiterlimit: 10
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M69.2933 57.4563L65.4211 57.7987",
    stroke: "#C3C8FF",
    strokeWidth: 1.14549,
    strokeMiterlimit: 10
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M83.5327 49.7744L85.2755 45.7798",
    stroke: "#C3C8FF",
    strokeWidth: 1.14549,
    strokeMiterlimit: 10
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M138.049 86.6685H162.06C162.895 86.6685 163.694 85.8322 163.846 84.7999L166.327 67.8807C166.478 66.8489 165.924 66.0121 165.089 66.0121H141.079C140.244 66.0121 139.444 66.8484 139.293 67.8807L136.812 84.7999C136.661 85.8317 137.215 86.6685 138.049 86.6685Z",
    fill: "#E0D5F8"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M157.3 77.6549C158.001 76.8636 158.136 75.636 157.602 74.9131C157.067 74.1902 156.066 74.2457 155.365 75.037C154.664 75.8283 154.529 77.0558 155.063 77.7787C155.598 78.5017 156.599 78.4462 157.3 77.6549Z",
    fill: "white"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M152.53 77.6549C153.231 76.8636 153.366 75.6361 152.832 74.9131C152.298 74.1902 151.296 74.2457 150.595 75.037C149.895 75.8283 149.76 77.0558 150.294 77.7787C150.828 78.5017 151.829 78.4462 152.53 77.6549Z",
    fill: "white"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M147.761 77.6549C148.461 76.8636 148.597 75.6361 148.062 74.9131C147.528 74.1902 146.527 74.2457 145.826 75.037C145.125 75.8283 144.99 77.0558 145.524 77.7787C146.058 78.5017 147.06 78.4462 147.761 77.6549Z",
    fill: "white"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M150.973 85.5557L142.63 91.684L144.125 85.0724L150.973 85.5557Z",
    fill: "#E0D5F8"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M60.7005 84.1606H36.6898C35.8551 84.1606 35.0554 83.3243 34.904 82.292L32.4229 65.3727C32.2715 64.3409 32.8259 63.5042 33.6606 63.5042H57.6713C58.5061 63.5042 59.3057 64.3405 59.4571 65.3727L61.9383 82.292C62.0897 83.3238 61.5357 84.1606 60.7005 84.1606Z",
    fill: "#C3C8FF"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M43.6762 75.2631C44.2104 74.5402 44.0754 73.3127 43.3745 72.5213C42.6736 71.73 41.6723 71.6746 41.138 72.3975C40.6038 73.1204 40.7389 74.3479 41.4397 75.1393C42.1406 75.9306 43.1419 75.986 43.6762 75.2631Z",
    fill: "white"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M48.4468 75.2631C48.9811 74.5402 48.846 73.3127 48.1451 72.5214C47.4442 71.73 46.443 71.6746 45.9087 72.3975C45.3744 73.1204 45.5095 74.3479 46.2104 75.1393C46.9113 75.9306 47.9126 75.986 48.4468 75.2631Z",
    fill: "white"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M53.2164 75.2637C53.7507 74.5408 53.6156 73.3132 52.9148 72.5219C52.2139 71.7306 51.2126 71.6752 50.6783 72.3981C50.1441 73.121 50.2791 74.3485 50.98 75.1398C51.6809 75.9311 52.6822 75.9866 53.2164 75.2637Z",
    fill: "white"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M52.1363 83.0478L53.4533 88.9635L58.7797 82.6338L52.1363 83.0478Z",
    fill: "#C3C8FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSolutions);
export default __webpack_public_path__ + "static/media/solutions.9e8c487d43e9e78515508ef17406b372.svg";
export { ForwardRef as ReactComponent };